var _script;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolkadot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,54.901961%,0%)",
      fillOpacity: 1
    },
    d: "M 128 64 C 128 99.347656 99.347656 128 64 128 C 28.652344 128 0 99.347656 0 64 C 0 28.652344 28.652344 0 64 0 C 99.347656 0 128 28.652344 128 64 Z M 128 64 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 64 18.011719 C 44.984375 18.011719 29.441406 33.460938 29.441406 52.570312 C 29.441406 56.410156 30.078125 60.160156 31.269531 63.816406 C 32.089844 66.285156 34.835938 67.65625 37.394531 66.835938 C 39.863281 66.011719 41.234375 63.269531 40.410156 60.707031 C 39.40625 57.875 38.949219 54.855469 39.039062 51.839844 C 39.40625 38.949219 49.828125 28.34375 62.71875 27.703125 C 77.074219 26.972656 88.960938 38.398438 88.960938 52.570312 C 88.960938 65.828125 78.539062 76.707031 65.460938 77.441406 C 65.460938 77.441406 60.617188 77.714844 58.238281 78.078125 C 57.050781 78.261719 56.136719 78.445312 55.496094 78.539062 C 55.222656 78.628906 54.949219 78.355469 55.039062 78.078125 L 55.863281 74.058594 L 60.34375 53.394531 C 60.890625 50.835938 59.246094 48.273438 56.6875 47.726562 C 54.125 47.175781 51.566406 48.824219 51.015625 51.382812 C 51.015625 51.382812 40.230469 101.667969 40.136719 102.21875 C 39.589844 104.777344 41.234375 107.335938 43.792969 107.886719 C 46.355469 108.433594 48.914062 106.789062 49.460938 104.230469 C 49.554688 103.679688 51.015625 97.003906 51.015625 97.003906 C 52.113281 91.886719 56.320312 88.136719 61.257812 87.496094 C 62.355469 87.3125 66.652344 87.039062 66.652344 87.039062 C 84.480469 85.667969 98.558594 70.765625 98.558594 52.570312 C 98.558594 33.460938 83.015625 18.011719 64 18.011719 Z M 66.46875 97.554688 C 63.359375 96.914062 60.25 98.835938 59.613281 102.035156 C 58.972656 105.144531 60.890625 108.25 64.089844 108.890625 C 67.199219 109.53125 70.308594 107.613281 70.949219 104.410156 C 71.589844 101.210938 69.667969 98.195312 66.46875 97.554688 Z M 66.46875 97.554688 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolkadot);
export default __webpack_public_path__ + "static/media/polkadot.4454249e2f4927e055ae7d2b1e26d2fb.svg";
export { ForwardRef as ReactComponent };